import { Component, effect, inject, linkedSignal } from '@angular/core';
import { RouterModule } from '@angular/router';

import { EtapeStore } from '../../référentiel-métier-parcours/parcours-etape/store/etape.store';
import { ModuleStore } from '../../référentiel-métier-parcours/parcours-module/store/module.store';
import { BreadcrumbScenarisationComponent } from '../../shared/components/breadcrumb-scenarisation/breadcrumb-scenarisation.component';
import { HeaderCartographieComponent } from '../components/header-cartographie/header-cartographie.component';

@Component({
  selector: 'app-scenarisation-layout',
  imports: [RouterModule, HeaderCartographieComponent, BreadcrumbScenarisationComponent],
  templateUrl: './scenarisation-layout.component.html',
})
export class ScenarisationLayoutComponent {
  readonly #moduleStore = inject(ModuleStore);
  readonly #etapeStore = inject(EtapeStore);

  readonly moduleSelected = this.#moduleStore.selectedEntity;
  readonly etape = linkedSignal(() => this.#etapeStore.selectedEntity());

  constructor() {
    effect(() => {
      const module = this.moduleSelected();

      if (module) {
        this.#etapeStore.select({ id: module.idEtape });
      }
    });
  }
}
